import CharacterCounter from 'components/CharacterCounter';
import { useField } from 'formik';
import * as React from 'react';

import type { CharacterCounterProps } from 'components/CharacterCounter';
import type { FieldProps } from 'formik';

type CharacterCounterFormFieldProps = CharacterCounterProps & FieldProps;

function CharacterCounterFormField({ field, helperText: helperTextProp, ...props }: CharacterCounterFormFieldProps) {
  const inputName = field.name;
  const [, meta] = useField(inputName);

  const isError = meta.touched && !!meta.error;
  const helperText = isError ? meta.error : helperTextProp;

  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      field.onChange(e);
      props.onChange?.(e);
    },
    [field, props]
  );

  const handleBlur = React.useCallback(
    (e: React.FocusEvent<HTMLTextAreaElement>) => {
      field.onBlur(e);
      props.onBlur?.(e);
    },
    [field, props]
  );

  return (
    <CharacterCounter
      {...props}
      value={field.value}
      name={inputName}
      onChange={handleChange}
      onBlur={handleBlur}
      helperText={helperText}
      error={isError}
    />
  );
}

export { CharacterCounterFormField };
